import { createStyles, makeStyles } from "@material-ui/core/styles";

const drawerWidth = 240;

export const useStyles = makeStyles(() =>
  createStyles({
    drawerPaper: {
      width: drawerWidth,
    },
  })
);
